module.exports = __webpack_public_path__ + "img/chris (22).cbc11e45.jpg";